import styled from "@emotion/styled";

export const Footer = styled.footer`
position: fixed;
bottom: 0;
left: 0;
width: 100%;
background-color: #2E2F42;
color: #FFFFFF;
padding: 10px;
text-align: center;

p {
  margin: 0;
}
`